var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.text_body)+" "),_c('router-link',{staticClass:"link",attrs:{"to":_vm.path}},[_vm._v(" "+_vm._s(_vm.text_link)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }